import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { premiumFontCss } from '@root/entities/premium/ui'
import { Drawer } from '@root/shared/ui-kit'

import { ExtendPremium } from '../../common/extend-premium'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium/atoms'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'open' | 'onOpenChange'> & {
  currency: CurrencyModel
  premium: PremiumMetaModel
}

export const ExtendPremiumDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  currency,
  premium,
}) => {
  return (
    <Root noBodyStyles open={open} onOpenChange={onOpenChange}>
      <Body>
        <Title>
          <Trans
            i18nKey={'premium.extend.title'}
            components={[<TitleAccent key={0} />]}
          />
        </Title>

        <ExtendPremium
          currency={currency}
          premium={premium}
          onClose={() => {
            onOpenChange?.(false)
          }}
          device="mobile"
        />
      </Body>
    </Root>
  )
}

const Root = styled(Drawer)`
  background: var(--appearance-1);
  background-image: radial-gradient(
    55% 130px at 50% -5%,
    rgba(var(--background-9-rgb), 0.2) 30%,
    transparent 100%
  );
`

const Body = styled.div`
  overflow: hidden;
  display: grid;

  padding: 10px 12px 32px;
`

const Title = styled(Typography).attrs({
  variant: 'body1-bold',
  component: 'h2',
})`
  color: var(--textA-12);
  text-align: center;
`

const TitleAccent = styled(Typography).attrs({
  variant: 'h4',
  component: 'span',
})`
  ${premiumFontCss}
  font-size: 18px;
  line-height: 20px;
`
